module.exports = __webpack_public_path__ + "static/media/Tollinton Market c. 1907.4fd16b00.jpg";